import React, { useEffect, useState } from "react";
import { fetchProducts } from "../../services/productsService";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../../firebaseConfig";
import SearchbarDestinataire from "../../components/SearchbarDestinataire";

const FitCreateOrder = () => {
  const [revendeurs, setRevendeurs] = useState([]);
  const [carrossiers, setCarrossiers] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedRevendeur, setSelectedRevendeur] = useState("");
  const [selectedDestinataire, setSelectedDestinataire] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [orderName, setOrderName] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [serviceDate, setServiceDate] = useState("");
  const [clientAffaireNumber, setClientAffaireNumber] = useState("");
  const [clientOrderNumber, setClientOrderNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        console.log("🔍 Récupération des utilisateurs...");
        console.log("🔐 Utilisateur actuel:", auth.currentUser?.uid);
        
        const snapshot = await getDocs(collection(db, "users_webapp"));
        const revs = [];
        const carros = [];
        
        console.log(`📊 Nombre total d'utilisateurs trouvés: ${snapshot.docs.length}`);
        
        if (snapshot.docs.length === 0) {
          console.error("❌ Aucun document trouvé dans users_webapp - Problème de permissions Firestore probable");
          return;
        }
        
        snapshot.docs.forEach((doc) => {
          const data = doc.data();
          const role = (data.role || "").trim();
          const user = {
            id: doc.id,
            ...data,
            company: data.company || data.Nom || data.nom || "Société inconnue",
            contact: data.Contact || data.contact || "",
          };
          
          console.log(`👤 Utilisateur ${doc.id}:`, {
            role: role,
            roleOriginal: data.role,
            isApproved: data.isApproved,
            company: user.company,
            email: data.email
          });
          
          const roleNormalized = role.toLowerCase();
          console.log(`🔄 Rôle normalisé pour ${user.company}: "${roleNormalized}"`);
          
          const isApprovedOrDefault = data.isApproved === true || data.isApproved === undefined;
          
          if (isApprovedOrDefault) {
            if (roleNormalized === "revendeur") {
              revs.push(user);
              console.log("✅ Revendeur ajouté:", user.company);
            } else if (roleNormalized === "carrossier") {
              carros.push(user);
              console.log("✅ Carrossier ajouté:", user.company);
            } else {
              console.log(`⚠️ Rôle non reconnu pour ${user.company}: "${roleNormalized}"`);
            }
          } else {
            console.log("⛔ Utilisateur non approuvé:", user.company);
          }
        });
        
        console.log(`📈 Résultats finaux: ${revs.length} revendeurs, ${carros.length} carrossiers`);
        setRevendeurs(revs);
        setCarrossiers(carros);
      } catch (err) {
        console.error("❌ Erreur récupération des utilisateurs :", err);
      }
    };

    fetchUsers();
    fetchProducts().then(setProducts).catch(console.error);
  }, []);

  useEffect(() => {
    if (deliveryDate) {
      const newDate = new Date(deliveryDate);
      newDate.setMonth(newDate.getMonth() + 6);
      setServiceDate(newDate.toISOString().split("T")[0]);
    }
  }, [deliveryDate]);

  // 🚀 NOUVELLE FONCTION : Génération automatique de l'URL de déclaration CE par produit
  const generateDeclarationCEUrl = (productId, productName) => {
    // Construction d'une URL basée sur le productId
    const API_BASE_URL = window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://veryfit.onrender.com";
    
    // URL vers le générateur de déclaration CE spécifique au produit
    const declarationCEUrl = `${API_BASE_URL}/api/generate/declaration-ce-produit/${productId}`;
    
    console.log(`📄 URL Déclaration CE générée pour ${productName}: ${declarationCEUrl}`);
    return declarationCEUrl;
  };

  // 🔹 Fonction pour obtenir les documents selon le destinataire
  const getDocumentsForDestinataire = (destinataireType) => {
    if (!destinataireType) return [];
    
    const roleNormalized = destinataireType.toLowerCase();
    
    if (roleNormalized === 'carrossier') {
      return [
        { 
          key: 'controleMontage', 
          label: 'Contrôle de Montage et Mise en Service', 
          required: true, 
          description: 'À remplir, signer et envoyer à FIT',
          icon: '✍️'
        },
        { 
          key: 'declarationCE', 
          label: 'Déclaration de Conformité CE', 
          required: true, 
          readOnly: true,
          description: 'PDF fourni par FIT - Généré automatiquement',
          icon: '📄'
        },
        { 
          key: 'noticeInstruction', 
          label: 'Notice d\'Instruction', 
          required: true,
          description: 'Disponible sur Google Drive',
          icon: '🔗'
        }
      ];
    } else if (roleNormalized === 'revendeur') {
      return [
        { 
          key: 'controlePeriodique', 
          label: 'Contrôle Périodique', 
          required: true,
          description: 'À effectuer 6 mois après création du dossier',
          icon: '🔍'
        },
        { 
          key: 'noticeInstruction', 
          label: 'Notice d\'Instruction', 
          required: true,
          description: 'Disponible sur Google Drive',
          icon: '🔗'
        }
      ];
    }
    return [];
  };

  // 🔹 Mise à jour du destinataire sélectionné - MODIFIÉE pour la searchbar
  const handleDestinataireChange = (userId) => {
    setSelectedRevendeur(userId);
    
    const destinataire = [...revendeurs, ...carrossiers].find((u) => u.id === userId);
    setSelectedDestinataire(destinataire);
    
    // Mettre à jour les documents des produits existants
    const documentsDisponibles = getDocumentsForDestinataire(destinataire?.role);
    const newDocumentsChoisis = {};
    
    documentsDisponibles.forEach(doc => {
      newDocumentsChoisis[doc.key] = doc.required;
    });
    
    setSelectedProducts(prevProducts => 
      prevProducts.map(product => ({
        ...product,
        documentsChoisis: newDocumentsChoisis
      }))
    );
  };

  // ✅ FONCTION : Génération de nom unique pour les doublons
  const generateUniqueFileName = (newFileName, existingFiles) => {
    if (!existingFiles || existingFiles.length === 0) return newFileName;
    
    const existingNames = existingFiles.map(file => file.name);
    
    // Si le nom n'existe pas déjà, le retourner tel quel
    if (!existingNames.includes(newFileName)) return newFileName;
    
    // Extraire le nom et l'extension
    const lastDotIndex = newFileName.lastIndexOf('.');
    const baseName = lastDotIndex > 0 ? newFileName.substring(0, lastDotIndex) : newFileName;
    const extension = lastDotIndex > 0 ? newFileName.substring(lastDotIndex) : '';
    
    // Chercher un nom disponible avec suffixe (2), (3), etc.
    let counter = 2;
    let uniqueName;
    
    do {
      uniqueName = `${baseName} (${counter})${extension}`;
      counter++;
    } while (existingNames.includes(uniqueName));
    
    console.log(`🔄 Nom unique généré: ${newFileName} → ${uniqueName}`);
    return uniqueName;
  };

  // ✅ FONCTION : Validation des fichiers
  const validateFiles = (files) => {
    const errors = [];
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = ['application/pdf'];
    
    files.forEach((file, index) => {
      if (file.size > maxSize) {
        errors.push(`Fichier ${file.name}: Taille trop importante (${Math.round(file.size / 1024 / 1024)}MB > 10MB)`);
      }
      
      if (!allowedTypes.includes(file.type)) {
        errors.push(`Fichier ${file.name}: Type non autorisé (${file.type}). Seuls les PDF sont acceptés.`);
      }
    });
    
    return errors;
  };

  // ✅ FONCTION PRINCIPALE : Mise à jour des produits avec gestion des fichiers
  const updateProduct = (index, key, value) => {
    const updated = [...selectedProducts];
    
    if (key === "files") {
      // Validation des fichiers avant traitement
      const inputElement = value.target;
      const newFiles = Array.from(inputElement.files);
      const errors = validateFiles(newFiles);
      
      if (errors.length > 0) {
        alert(`❌ Erreurs détectées :\n\n${errors.join('\n')}`);
        inputElement.value = ''; // Reset l'input
        return;
      }
      
      const existingFiles = updated[index].files || [];
      
      console.log(`🔄 Ajout de ${newFiles.length} nouveau(x) fichier(s) au produit ${index + 1}`);
      console.log(`📊 Fichiers existants: ${existingFiles.length}`);
      
      // ✅ TRAITEMENT DES DOUBLONS : Renommer automatiquement les fichiers en doublon
      const processedFiles = newFiles.map(file => {
        const uniqueName = generateUniqueFileName(file.name, existingFiles);
        
        // Si le nom a changé, créer un nouveau fichier avec le nom unique
        if (uniqueName !== file.name) {
          console.log(`🔄 Fichier renommé: ${file.name} → ${uniqueName}`);
          
          // Créer un nouveau File object avec le nom unique
          const renamedFile = new File([file], uniqueName, {
            type: file.type,
            lastModified: file.lastModified
          });
          
          return renamedFile;
        }
        
        return file;
      });
      
      // Ajouter les fichiers traités à la liste existante
      updated[index].files = [...existingFiles, ...processedFiles];
      
      console.log(`📎 ${processedFiles.length} fichier(s) ajouté(s) au produit ${index + 1}`);
      console.log(`📊 Total fichiers pour ce produit: ${updated[index].files.length}`);
      
      // ✅ SOLUTION : Reset de l'input pour permettre la re-sélection du même fichier
      inputElement.value = '';
      console.log('🔄 Input file reseté pour permettre la re-sélection');
      
    } else if (key === "removeFile") {
      // ✅ Supprimer un fichier spécifique
      const removedFile = updated[index].files[value];
      updated[index].files = updated[index].files.filter((_, fileIndex) => fileIndex !== value);
      console.log(`🗑️ Fichier supprimé: ${removedFile?.name}`);
      
    } else if (key === "clearAllFiles") {
      // ✅ Supprimer tous les fichiers
      updated[index].files = [];
      console.log(`🗑️ Tous les fichiers supprimés pour le produit ${index + 1}`);
      
    } else if (key.startsWith("documentsChoisis.")) {
      const docKey = key.split(".")[1];
      updated[index].documentsChoisis[docKey] = value;
    } else {
      updated[index][key] = value;
    }
    
    setSelectedProducts(updated);
  };

  // ✅ FONCTION : Rendu de la section fichiers améliorée
  const renderFileSection = (product, index) => (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <input 
          type="file" 
          accept="application/pdf" 
          multiple 
          onChange={(e) => updateProduct(index, "files", e)} 
          className="p-2 border rounded flex-1" 
          title="Fichiers PDF optionnels (instructions/références) - Sélection multiple possible"
          key={`file-input-${index}-${product.files?.length || 0}`} // Key dynamique pour forcer le refresh
        />
        <div className="text-sm text-gray-600 bg-blue-50 px-3 py-2 rounded border flex items-center gap-2">
          <span className="text-blue-600">🔄</span>
          <strong>Doublons auto-renommés</strong>
        </div>
      </div>
      
      {/* Affichage des fichiers sélectionnés */}
      {product.files && product.files.length > 0 && (
        <div className="bg-gray-50 p-3 rounded border">
          <div className="flex items-center justify-between mb-2">
            <h5 className="text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className="text-blue-600">📎</span>
              Fichiers sélectionnés ({product.files.length})
            </h5>
            <button
              type="button"
              onClick={() => updateProduct(index, "clearAllFiles")}
              className="text-xs text-red-600 hover:text-red-800 bg-red-50 hover:bg-red-100 px-2 py-1 rounded border transition-colors"
              title="Supprimer tous les fichiers"
            >
              🗑️ Tout supprimer
            </button>
          </div>
          
          <div className="space-y-1 max-h-48 overflow-y-auto">
            {product.files.map((file, fileIndex) => {
              // Détection des fichiers renommés
              const isRenamed = file.name.includes(' (') && file.name.includes(')');
              const isDuplicate = product.files.filter(f => f.name.startsWith(file.name.split(' (')[0])).length > 1;
              
              return (
                <div key={`${fileIndex}-${file.name}`} className="flex items-center justify-between bg-white p-2 rounded border text-sm hover:bg-gray-50 transition-colors">
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="text-blue-600 flex-shrink-0">📄</span>
                    <span 
                      className={`text-gray-700 truncate ${isRenamed ? 'font-medium' : ''}`} 
                      title={file.name}
                    >
                      {file.name}
                    </span>
                    
                    {/* Badges visuels */}
                    {isRenamed && (
                      <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full flex-shrink-0 flex items-center gap-1">
                        <span>🔄</span>
                        Renommé
                      </span>
                    )}
                    
                    {isDuplicate && !isRenamed && (
                      <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full flex-shrink-0 flex items-center gap-1">
                        <span>⚠️</span>
                        Doublon détecté
                      </span>
                    )}
                    
                    <span className="text-xs text-gray-400 flex-shrink-0">
                      ({(file.size / 1024).toFixed(1)} KB)
                    </span>
                  </div>
                  
                  <button
                    type="button"
                    onClick={() => updateProduct(index, "removeFile", fileIndex)}
                    className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1 rounded ml-2 flex-shrink-0 transition-colors"
                    title="Supprimer ce fichier"
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </div>
          
          {/* Conseils et statistiques */}
          <div className="mt-3 p-2 bg-blue-50 rounded border-l-4 border-blue-400">
            <div className="flex items-start gap-2">
              <span className="text-blue-600 text-sm">💡</span>
              <div className="text-xs text-blue-700">
                <p className="font-medium mb-1">Conseils :</p>
                <ul className="space-y-1">
                  <li>• Les fichiers avec le même nom sont automatiquement renommés</li>
                  <li>• Vous pouvez ajouter le même fichier plusieurs fois</li>
                  <li>• Formats acceptés : PDF uniquement</li>
                  <li>• Taille max : 10MB par fichier</li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Résumé des fichiers */}
          <div className="mt-2 text-xs text-gray-600 bg-gray-100 p-2 rounded">
            <div className="flex justify-between items-center">
              <span>📊 <strong>Résumé :</strong></span>
              <span>
                {product.files.length} fichier{product.files.length > 1 ? 's' : ''} • 
                {Math.round(product.files.reduce((total, f) => total + f.size, 0) / 1024)} KB total
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const handleCreateOrder = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    setLoading(true);
    const dossierId = uuidv4();

    try {
      const destinataire = [...revendeurs, ...carrossiers].find((r) => r.id === selectedRevendeur);
      const destinataireEmail = destinataire?.email || "";

      // 🚀 MODIFICATION : Création des produits avec URLs de déclaration CE
      const produitsAvecInfos = selectedProducts.map((prod) => {
        const produitComplet = products.find((p) => p.id === prod.productId);
        const productId = produitComplet?.id || "";
        const productName = produitComplet?.name || "";
        
        // 🔥 GÉNÉRATION AUTOMATIQUE DE L'URL DE DÉCLARATION CE
        const declarationCEUrl = generateDeclarationCEUrl(productId, productName);
        
        // 🚀 NOUVELLE STRUCTURE : Avec documents et URL de déclaration CE
        const produitStructure = {
          uuid: uuidv4(),
          ...prod,
          productId,
          name: productName,
          fileCount: prod.files ? prod.files.length : 0,
          typeFormulaire: productName.trim().toUpperCase() === "FIT CLEVER SAFE HUSKY" ? "typeB" : "typeA",
          filled: false,
          formulaireData: null,
          documentsChoisis: prod.documentsChoisis,
          
          // 🔥 AJOUT : Structure documents avec déclaration CE
          documents: {
            controleMontage: {
              status: "à remplir",
              url: ""
            },
            declarationCE: {
              status: "disponible", // 🚀 Changé de "à remplir" à "disponible"
              url: declarationCEUrl // 🚀 URL générée automatiquement
            },
            declarationMontage: {
              status: "à remplir",
              url: ""
            },
            controlePeriodique: {
              status: "en_attente",
              url: "",
              availableDate: new Date(Date.now() + (6 * 30 * 24 * 60 * 60 * 1000)) // +6 mois
            },
            noticeUtilisation: {
              status: "disponible",
              url: "https://drive.google.com/drive/u/0/folders/1SkwJS3TckM34AMIVnZ5QW8zV-R6oN5yK"
            }
          }
        };

        console.log(`📄 Produit ${productName} créé avec déclaration CE: ${declarationCEUrl}`);
        return produitStructure;
      });

      // Support fichiers multiples
      const formDataToSend = new FormData();
      selectedProducts.forEach((prod, index) => {
        if (prod.files && prod.files.length > 0) {
          prod.files.forEach((file, fileIndex) => {
            formDataToSend.append(`file_produit_${index}_${fileIndex}`, file);
          });
        }
      });

      const payload = {
        id: dossierId,
        orderName,
        revendeur: selectedRevendeur,
        revendeurEmail: destinataireEmail,
        destinataire_type: destinataire?.role || "Revendeur",
        produits: produitsAvecInfos,
        deliveryDate,
        serviceDate,
        clientAffaireNumber,
        clientOrderNumber,
        status: "en_attente_remplissage",
        createdAt: new Date().toISOString(),
      };

      formDataToSend.append("data", JSON.stringify(payload));

      console.log("📦 Envoi du dossier avec déclarations CE automatiques:", payload);

      const API_BASE_URL =
        window.location.hostname === "localhost"
          ? "http://localhost:5000"
          : "https://veryfit.onrender.com";

      console.log("🌐 URL API utilisée:", `${API_BASE_URL}/api/dossiers/create`);

      const response = await fetch(`${API_BASE_URL}/api/dossiers/create`, {
        method: "POST",
        body: formDataToSend,
      });

      console.log("📡 Réponse status:", response.status);
      console.log("📡 Réponse OK:", response.ok);

      if (!response.ok) {
        let errorText = "Erreur inconnue";
        try {
          const errorData = await response.json();
          errorText = errorData.details || errorData.error || errorData.message || "Erreur serveur";
          console.error("❌ Détail erreur serveur:", errorData);
        } catch (e) {
          try {
            errorText = await response.text();
            console.error("❌ Erreur serveur (texte):", errorText);
          } catch (e2) {
            console.error("❌ Impossible de lire l'erreur serveur:", e2);
          }
        }
        throw new Error(`Erreur création dossier: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      console.log("✅ Réponse serveur:", result);

      alert("✅ Dossier CE créé avec succès.\n📄 Les déclarations CE ont été générées automatiquement pour chaque produit !");
      resetForm();
      
    } catch (error) {
      console.error("🚨 Erreur création dossier CE :", error);
      console.error("🚨 Stack trace:", error.stack);
      
      let userMessage = "Erreur création du dossier.";
      if (error.message.includes("500")) {
        userMessage = "Erreur serveur. Consultez les logs pour plus de détails.";
      } else if (error.message.includes("400")) {
        userMessage = "Données invalides. Vérifiez le formulaire.";
      } else if (error.message.includes("Failed to fetch")) {
        userMessage = "Impossible de contacter le serveur. Vérifiez votre connexion.";
      } else if (error.message.includes("NetworkError")) {
        userMessage = "Problème de réseau. Réessayez dans quelques instants.";
      }
      
      alert(userMessage + "\n\nDétail technique: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const validateFields = () => {
    if (!orderName) {
      alert("Numéro de dossier manquant.");
      return false;
    }
    if (!selectedRevendeur) {
      alert("Sélectionnez un destinataire.");
      return false;
    }
    if (!selectedProducts.length) {
      alert("Ajoutez au moins un produit.");
      return false;
    }
    if (!deliveryDate) {
      alert("Date de livraison manquante.");
      return false;
    }
    
    for (let i = 0; i < selectedProducts.length; i++) {
      if (!selectedProducts[i].productId) {
        alert(`Sélectionnez un produit pour la ligne ${i + 1}.`);
        return false;
      }
    }
    
    return true;
  };

  const resetForm = () => {
    setOrderName("");
    setSelectedRevendeur("");
    setSelectedDestinataire(null);
    setSelectedProducts([]);
    setDeliveryDate("");
    setServiceDate("");
    setClientAffaireNumber("");
    setClientOrderNumber("");
  };

  const addProduct = () => {
    const documentsDisponibles = getDocumentsForDestinataire(selectedDestinataire?.role);
    const newDocumentsChoisis = {};
    
    documentsDisponibles.forEach(doc => {
      newDocumentsChoisis[doc.key] = doc.required;
    });

    setSelectedProducts(prevProducts => [
      ...prevProducts,
      {
        productId: "",
        quantity: 1,
        files: [],
        documentsChoisis: newDocumentsChoisis,
      },
    ]);
  };

  const removeProduct = (index) => {
    const updated = selectedProducts.filter((_, i) => i !== index);
    setSelectedProducts(updated);
  };

  const productsByCategory = {
    "VAT RETROFIT": [],
    "CLEVER RETROFIT": [],
    "CLEVER SAFE": [],
  };

  const vatRetrofitProducts = [
    "FIT VAT BOIS",
    "FIT VAT CC",
    "FIT VAT FORTY",
    "FIT VAT RR",
    "FIT VAT HUSKY",
  ];

  const cleverRetrofitProducts = [
    "FIT CLEVER BOIS",
    "FIT CLEVER CC",
    "FIT CLEVER FORTY",
    "FIT CLEVER RR",
    "FIT CLEVER HUSKY",
  ];

  const cleverSafeProducts = [
    "FIT CLEVER SAFE BOIS",
    "FIT CLEVER SAFE CC",
    "FIT CLEVER SAFE FORTY",
    "FIT CLEVER SAFE RR",
    "FIT CLEVER SAFE HUSKY",
  ];

  products.forEach((product) => {
    const name = (product.name || "").trim().toUpperCase();
    const categorie = (product.categorie || "").trim().toUpperCase();

    if (vatRetrofitProducts.includes(name) || categorie === "VAT RETROFIT") {
      productsByCategory["VAT RETROFIT"].push(product);
    } else if (cleverRetrofitProducts.includes(name) || categorie === "CLEVER RETROFIT") {
      productsByCategory["CLEVER RETROFIT"].push(product);
    } else if (cleverSafeProducts.includes(name) || categorie === "CLEVER SAFE" || categorie === "SAFE") {
      productsByCategory["CLEVER SAFE"].push(product);
    }
  });

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-2xl font-bold text-center text-darkBlue mb-6">
        CRÉATION D'UN DOSSIER CE
      </h1>

      <form
        onSubmit={handleCreateOrder}
        encType="multipart/form-data"
        className="bg-white shadow-lg rounded-lg p-8 max-w-5xl mx-auto space-y-8"
      >
        <div className="grid grid-cols-2 gap-4">
          <input 
            type="text" 
            placeholder="Numéro du dossier" 
            value={orderName} 
            onChange={(e) => setOrderName(e.target.value)} 
            className="p-3 border rounded" 
            required
          />
          <input 
            type="text" 
            placeholder="Numéro d'affaire client" 
            value={clientAffaireNumber} 
            onChange={(e) => setClientAffaireNumber(e.target.value)} 
            className="p-3 border rounded" 
          />
          <input 
            type="text" 
            placeholder="Numéro de commande client" 
            value={clientOrderNumber} 
            onChange={(e) => setClientOrderNumber(e.target.value)} 
            className="p-3 border rounded" 
          />
          
          {/* 🚀 REMPLACEMENT DU SELECT PAR LA SEARCHBAR */}
          <SearchbarDestinataire
            revendeurs={revendeurs}
            carrossiers={carrossiers}
            selectedValue={selectedRevendeur}
            onSelect={handleDestinataireChange}
            placeholder="Rechercher un destinataire par nom, email ou type..."
          />
          
          <input 
            type="date" 
            value={deliveryDate} 
            onChange={(e) => setDeliveryDate(e.target.value)} 
            className="p-3 border rounded" 
            required
            placeholder="Date de livraison"
          />
          <input 
            type="date" 
            value={serviceDate} 
            disabled 
            className="p-3 border rounded bg-gray-100" 
            title={selectedDestinataire?.role?.toLowerCase() === 'carrossier' ? 
              "Date de contrôle périodique (à effectuer par un revendeur dans 6 mois)" : 
              "Date de contrôle périodique (à effectuer par le revendeur)"
            }
            placeholder="Date contrôle périodique (+6 mois)"
          />
        </div>
       
        <div>
          <h2 className="font-bold text-lg mb-4">PRODUITS</h2>
          
          {/* 🚀 INFORMATION DÉCLARATION CE AUTOMATIQUE */}
          {selectedDestinataire?.role?.toLowerCase() === 'carrossier' && (
            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-start gap-3">
                <span className="text-blue-600 text-lg">📄</span>
                <div>
                  <h3 className="font-semibold text-blue-800 mb-2">
                    Génération automatique des déclarations CE
                  </h3>
                  <p className="text-sm text-blue-700 mb-2">
                    Pour chaque produit ajouté, une déclaration de conformité CE sera automatiquement générée et disponible au téléchargement.
                  </p>
                  <ul className="text-xs text-blue-600 space-y-1">
                    <li>• ✅ URL de téléchargement générée automatiquement</li>
                    <li>• ✅ Disponible immédiatement après création du dossier</li>
                    <li>• ✅ Un PDF par produit dans le dossier</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {selectedProducts.map((product, index) => (
            <div key={index} className="border p-4 rounded mb-4 space-y-4 relative bg-gray-50">
              <button
                type="button"
                onClick={() => removeProduct(index)}
                className="absolute top-2 right-2 text-red-500 hover:text-red-700 font-bold text-xl"
                title="Supprimer ce produit"
              >
                ×
              </button>
              
              <select 
                value={product.productId} 
                onChange={(e) => updateProduct(index, "productId", e.target.value)} 
                className="p-3 border rounded w-full"
                required
              >
                <option value="">-- Sélectionnez un produit --</option>
                {Object.entries(productsByCategory).map(([category, produits]) => (
                  produits.length > 0 && (
                    <optgroup key={category} label={`📦 ${category}`}>
                      {produits.map((p) => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </optgroup>
                  )
                ))}
              </select>
              
              <input 
                type="number" 
                min={1} 
                value={product.quantity} 
                onChange={(e) => updateProduct(index, "quantity", parseInt(e.target.value) || 1)} 
                className="p-3 border rounded w-full" 
                placeholder="Quantité"
              />
              
              {/* ✅ SECTION FICHIERS AMÉLIORÉE - Utilisation de renderFileSection */}
              {renderFileSection(product, index)}
              
              {/* Documents dynamiques selon le destinataire */}
              {selectedDestinataire && (
                <div className="bg-white p-3 rounded border">
                  <h4 className="font-semibold text-sm mb-3 text-gray-800 border-b pb-2">
                    📄 Documents à envoyer pour {selectedDestinataire.role}:
                  </h4>
                  <div className="space-y-2">
                    {getDocumentsForDestinataire(selectedDestinataire.role).map((doc) => (
                      <div key={doc.key} className="flex items-start gap-3 p-2 bg-gray-50 rounded">
                        <input 
                          type="checkbox" 
                          checked={product.documentsChoisis[doc.key] || false} 
                          onChange={(e) => updateProduct(index, `documentsChoisis.${doc.key}`, e.target.checked)} 
                          disabled={doc.required}
                          className="mt-1"
                        />
                        <div className="flex-1">
                          <span className={`text-sm font-medium ${doc.required ? 'text-blue-600' : 'text-gray-700'}`}>
                            {doc.icon} {doc.label} {doc.required ? '(requis)' : ''}
                          </span>
                          {doc.description && (
                            <div className="text-xs text-gray-500 mt-1">
                              {doc.description}
                            </div>
                          )}
                          
                          {/* 🚀 INDICATION SPÉCIALE POUR DÉCLARATION CE */}
                          {doc.key === 'declarationCE' && product.productId && (
                            <div className="text-xs text-green-600 mt-1 font-medium">
                              ✅ URL sera générée automatiquement pour ce produit
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {!selectedDestinataire && (
                <div className="text-sm text-gray-500 italic bg-yellow-50 p-3 rounded border border-yellow-200">
                  ⚠️ Sélectionnez d'abord un destinataire pour voir les documents disponibles
                </div>
              )}
            </div>
          ))}
          
          <button 
            type="button" 
            onClick={addProduct} 
            className={`font-bold mt-4 px-6 py-3 rounded transition-all ${
              selectedDestinataire 
                ? "text-blue-600 hover:text-blue-800 border border-blue-600 hover:bg-blue-50" 
                : "text-gray-400 border border-gray-300 cursor-not-allowed"
            }`}
            disabled={!selectedDestinataire}
          >
            + Ajouter un produit
          </button>
          
          {!selectedDestinataire && (
            <p className="text-sm text-gray-500 mt-2">
              Veuillez d'abord sélectionner un destinataire pour ajouter des produits
            </p>
          )}
        </div>

        {/* 🚀 RÉSUMÉ AVANT CRÉATION */}
        {selectedProducts.length > 0 && selectedDestinataire?.role?.toLowerCase() === 'carrossier' && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h3 className="font-semibold text-green-800 mb-3 flex items-center gap-2">
              <span>📋</span>
              Résumé des déclarations CE qui seront créées
            </h3>
            <div className="space-y-2">
              {selectedProducts.map((product, index) => {
                const produitComplet = products.find((p) => p.id === product.productId);
                if (!produitComplet) return null;
                
                const declarationCEUrl = generateDeclarationCEUrl(produitComplet.id, produitComplet.name);
                
                return (
                  <div key={index} className="flex items-center justify-between bg-white p-3 rounded border">
                    <div className="flex items-center gap-3">
                      <span className="text-green-600">📄</span>
                      <div>
                        <span className="font-medium text-gray-900">{produitComplet.name}</span>
                        <div className="text-xs text-gray-500">Quantité: {product.quantity}</div>
                      </div>
                    </div>
                    <div className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded">
                      ✅ CE auto-générée
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="mt-3 text-xs text-green-700">
              💡 <strong>Total:</strong> {selectedProducts.length} déclaration{selectedProducts.length > 1 ? 's' : ''} CE sera{selectedProducts.length > 1 ? 'nt' : ''} générée{selectedProducts.length > 1 ? 's' : ''} automatiquement.
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className={`w-full px-6 py-3 rounded shadow transition text-white font-bold ${
            loading ? "bg-gray-400 cursor-not-allowed" : "bg-red-600 hover:bg-red-700"
          }`}
        >
          {loading ? "Création en cours..." : "CRÉER LE DOSSIER CE"}
        </button>
      </form>
    </div>
  );
};

export default FitCreateOrder;